export default __webpack_public_path__ + "static/media/list-placeholder.07f1dcca.svg";